<template>
  <div class="fill-height">
    <AnimatedClouds />
    <v-row class="fill-height" align="center" justify="center" style="position: relative;">
      <v-col cols="12">
        <h1 class="text-center heading3">{{this.$root.siteSettings.siteTitle}}</h1>
        <h2 class="text-center">{{countdown}}</h2>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import AnimatedClouds from '@/atoms/AnimatedClouds'
import delay from 'lodash/delay'
import moment from 'moment-mini'

export default {
  name: 'TeaserPage',

  components: {
    AnimatedClouds
  },

  data () {
    return {
      now: moment().valueOf()
    }
  },

  mounted () {
    delay(this.updateNow, 1000)
  },

  methods: {
    updateNow () {
      this.now = moment().valueOf()
      delay(this.updateNow, 1000)
    }
  },

  computed: {
    countdown () {
      const dateTime = this.$root.siteSettings.teaserCountdownEndDate.split('T')[0] + ' ' + this.$root.siteSettings.teaserCountdownHours.split(' ')[0]

      const eventTime = moment(dateTime).utcOffset(this.$root.siteSettings.teaserCountdownHours.split(' ')[1], true).valueOf()

      // console.log(moment(dateTime).format('x'))
      // console.log(moment(dateTime).utcOffset('GMT+0500', true).format('x'))

      const diffTime = eventTime - this.now

      const duration = moment.duration(diffTime, 'milliseconds')
      // duration = moment.duration(duration - 1000, 'milliseconds')

      return `${Math.max(0, duration.days()).toString().padStart(2, '0')}:${Math.max(0, duration.hours()).toString().padStart(2, '0')}:${Math.max(0, duration.minutes()).toString().padStart(2, '0')}:${Math.max(0, duration.seconds()).toString().padStart(2, '0')}`
    }
  },

  metaInfo () {
    return {
      title: 'Stay Tuned'
    }
  }
}
</script>

<style lang="scss" scoped>

h2 {
  font-family: $heading-font-family;
  padding-top: 20px;
  font-size: 7rem;

  @include breakpoint('lg-and-down') {
    font-size: 6rem;
  }

  @include breakpoint('sm-and-down') {
    font-size: 5rem;
  }

  @include breakpoint('xs-only') {
    font-size: 4rem;
  }
}
</style>
